/**
 * Deterministic JSON: object keys are sorted recursively so identical
 * inputs produce byte-identical output (stable for golden assertions).
 */
export function stableStringify(value, indent = 2) {
    return JSON.stringify(sortKeys(value), null, indent) + '\n';
}
function sortKeys(value) {
    if (Array.isArray(value))
        return value.map(sortKeys);
    if (typeof value === 'object' && value !== null) {
        const out = {};
        for (const key of Object.keys(value).sort()) {
            const v = value[key];
            if (v !== undefined)
                out[key] = sortKeys(v);
        }
        return out;
    }
    return value;
}
export function reportToJson(report) {
    return stableStringify(report);
}
//# sourceMappingURL=json.js.map